import React from 'react';
import { motion } from 'framer-motion';
import { X, Check } from 'lucide-react';
export function TrustSection() {
  return <section className="w-full bg-warm-gray py-16 px-6 md:py-24" data-id="element-230">
      <div className="max-w-reading mx-auto" data-id="element-231">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="space-y-16" data-id="element-232">
          {/* What this is NOT */}
          <div className="bg-white p-8 rounded-xl shadow-sm border border-border-gray/50" data-id="element-233">
            <h3 className="text-2xl font-bold text-charcoal mb-6 font-serif border-b-2 border-border-gray pb-2" data-id="element-234">
              What this is NOT
            </h3>
            <ul className="space-y-4 mb-6" data-id="element-235">
              {['Not a medical diagnosis', 'Not a "cure" claim', 'Not a Kegels program', 'Not a dehydration plan', 'Not a shame-based "discipline" lecture'].map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-236">
                  <X className="w-5 h-5 text-red-400 mt-1 flex-shrink-0" data-id="element-237" />
                  <span className="text-lg text-charcoal/80" data-id="element-238">{item}</span>
                </li>)}
            </ul>
            <p className="text-charcoal/90 italic border-l-4 border-sage pl-4 py-1" data-id="element-239">
              It's a practical protocol + tracker designed to reduce wake-ups by
              removing common triggers.
            </p>
          </div>

          {/* Who this is for */}
          <div className="bg-white p-8 rounded-xl shadow-sm border border-border-gray/50" data-id="element-240">
            <h3 className="text-2xl font-bold text-charcoal mb-6 font-serif border-b-2 border-sage pb-2" data-id="element-241">
              Who this is for
            </h3>
            <ul className="space-y-4" data-id="element-242">
              {['Men 65+ waking up multiple times per night', 'Men who want something simple and private', 'Men who want a plan they can run this week', 'Men who are tired of guessing'].map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-243">
                  <Check className="w-5 h-5 text-sage-dark mt-1 flex-shrink-0" data-id="element-244" />
                  <span className="text-lg text-charcoal font-medium" data-id="element-245">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>

          {/* Disclaimer */}
          <div className="bg-amber/10 p-6 rounded-lg border border-amber/20" data-id="element-246">
            <h4 className="text-lg font-bold text-amber-hover mb-2 font-serif" data-id="element-247">
              Who this is not for
            </h4>
            <p className="text-charcoal/80 leading-relaxed" data-id="element-248">
              If you have severe pain, fever, blood in urine, sudden major
              changes, or serious heart/kidney concerns — get checked. This
              guide is educational and is designed to complement medical care,
              not replace it.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}